import { RIPPLING } from '@/integrations/modules/rippling/consts';
import type { RipplingRequestTypesData } from '@/integrations/modules/rippling/types';
import Integrations from '@/shared/api/integrations';

import { createAsyncThunk } from '@reduxjs/toolkit';

export const fetchRipplingRequestTypes = createAsyncThunk(
  'rippling/fetchRequestTypes',
  async (_, { rejectWithValue }) => {
    try {
      const response = await Integrations.get(`/${RIPPLING}/v2/config/request_types`);
      return response as { data: RipplingRequestTypesData };
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
